var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-card',[_c('template',{slot:"header"},[_vm._v("\n        "+_vm._s(_vm.header)+"\n    ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentHTML)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }